import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Button, Typography} from 'views/components';
import {DatePicker, Translate, translate} from 'views/module';

import moment from 'moment';

const SEVERITY_COLOR = {
  success: 'success.main',
  info: 'text.secondary',
  error: 'error.main',
};

const RegenerateInvoice = (props) => {
  const {clientBackend} = props;

  const [date, setDate] = React.useState(() => moment());
  const [isRegenerating, setIsRegenerating] = React.useState(false);
  const [result, setResult] = React.useState(null);

  const handleRegenerate = () => {
    if (!date || !date.isValid()) {
      return;
    }

    setIsRegenerating(true);
    setResult(null);

    const onSuccess = (output) => {
      setIsRegenerating(false);

      const weekOfDisplay = moment(output.weekOf, 'YYYY[Week]WW').format('YYYY-MM-DD');

      if (!output.regenerated) {
        setResult({
          severity: 'info',
          text: translate('client.ClientDetail.Payment.Regenerate.NoShifts', {date: weekOfDisplay}),
        });
        return;
      }

      if (output.invoice && output.invoice.succeed === false) {
        setResult({
          severity: 'error',
          text: translate('client.ClientDetail.Payment.Regenerate.InvoiceFailed', {
            date: weekOfDisplay,
            reason: output.invoice.failureReason || '',
          }),
        });
        return;
      }

      setResult({
        severity: 'success',
        text: translate('client.ClientDetail.Payment.Regenerate.Success', {date: weekOfDisplay}),
      });
    };

    const onError = () => {
      setIsRegenerating(false);
      setResult({
        severity: 'error',
        text: translate('client.ClientDetail.Payment.Regenerate.Error'),
      });
    };

    clientBackend.payment.regenerate(date.format('YYYY-MM-DD'), onSuccess, onError);
  };

  return (
    <Stack spacing={1}>
      <Typography sx={{fontWeight: 'bold'}}>
        <Translate expression="client.ClientDetail.Payment.Regenerate.Title" />
      </Typography>
      <Stack direction="row" spacing={1} alignItems="center">
        <DatePicker
          label={translate('client.ClientDetail.Payment.Regenerate.SelectDate')}
          value={date}
          onChange={setDate}
          slotProps={{
            textField: {
              size: 'small',
            },
          }}
        />
        <Button
          onClick={handleRegenerate}
          variant="contained"
          loading={isRegenerating}
          disabled={!date || !date.isValid()}
        >
          <Translate expression="client.ClientDetail.Payment.Regenerate.Action" />
        </Button>
      </Stack>
      {
        result &&
        <Typography sx={{color: SEVERITY_COLOR[result.severity]}}>
          {result.text}
        </Typography>
      }
    </Stack>
  );
};

RegenerateInvoice.propTypes = {
  clientBackend: PropTypes.object.isRequired,
};

export default React.memo(RegenerateInvoice);
